import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import MyScore from '../pages/MyScore';
import Steps from '../pages/Steps';
import Lag from '../pages/Lag';
import Faq from '../pages/Faq';
import LocationResults from '../pages/LocationResults';
import NotFound from '../pages/NotFound';
import Maintenance from '../pages/Maintenance';
import i18n from '../i18n';

export default (props) => (
  <Router basename={`${i18n.currentLanguage()}`}>
    <div>
      {props.children}
      <Switch>
        <Route exact path="/" component={process.env.MAINTENANCE === 'maintenance'? Maintenance : MyScore} />
        <Route path="/steps" component={Steps} />
        <Route path="/lag" component={Lag} />
        <Route path="/faq" component={Faq} />
        <Route path="/results/:shard/:location_id?" component={LocationResults} />
        <Route path="*" render={props => {
          return <NotFound />;
        }} />
      </Switch>
      <Route path="*" render={props => {
        if(window.location.pathname === '/') { //missing basename
          return <Redirect to="/" />;
        } else {
          return null;
        }
      }} />
    </div>
  </Router>
);



// WEBPACK FOOTER //
// ./src/routes/index.js